module.exports = __webpack_public_path__ + "img/error-top.c43b7e2e.svg";